import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../assets/images/logo.jpeg';

const links = [
  { href: '#about', label: 'About' },
  { href: '#principal', label: 'Principal' },
  { href: '#gallery', label: 'Gallery' },
  { href: '#facilities', label: 'Facilities' },
  { href: '#history', label: 'History' },
  { href: '#contact', label: 'Contact' },
];

export default function Navbar() {
  const [active, setActive] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const sections = document.querySelectorAll('section[id]');
      let cur = '';
      sections.forEach(s => { if (window.scrollY >= s.offsetTop - 110) cur = s.id; });
      setActive(cur);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <nav className="navbar">
      <div className="nav-inner">
        <a className="nav-brand" href="#home" onClick={close}>
          <div className="nav-logo">
            <img src={logo} alt="School Logo" />
          </div>
          <div className="nav-title">
            St. Xavier's English Medium School
            <span>Guledgudd · Bagalkot · Est. 2011</span>
          </div>
        </a>

        <ul className="nav-links">
          {links.map(l => (
            <li key={l.href}>
              <a href={l.href} className={active === l.href.slice(1) ? 'active' : ''}>
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a className="nav-admit" href="#contact">Admissions Open →</a>

        <button className="hamburger" onClick={() => setOpen(o => !o)} aria-label="Menu">
          <span className={open ? 'open' : ''} />
          <span className={open ? 'open' : ''} />
          <span className={open ? 'open' : ''} />
        </button>
      </div>

      <div className={`mob-menu ${open ? 'open' : ''}`}>
        {links.map(l => (
          <a key={l.href} href={l.href} onClick={close}>{l.label}</a>
        ))}
        <a href="#contact" onClick={close} className="mob-admit">Admissions Open →</a>
      </div>
    </nav>
  );
}
